<script>

import FirstCardDesign from '@/components/wizards/digitize/FirstCardDesign.vue';
import useMobileStyle from '@/mixins/useMobileStyle';
import bem from '@/utils/bem';

const b = bem('digitize-cards');
export default {
  data() {
    return {
      isShowCardModal: false,
    };
  },
  mixins: [useMobileStyle],
  props: {
    selectedStep: {
      type: Object,
      required: true,
    },
    productName: {
      type: String,
      required: true,
    },
    products: {
      type: Array,
      required: true,
    },
  },
  components: {
    FirstCardDesign,
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
  },
};

</script>

<template>
  <div :class="b('')">
    <template v-for="(section, index) in selectedStep.orderSections" v-bind:key="section.id">
      <FirstCardDesign
        :section="section"
        :is-film="false"
        v-if="selectedStep.designVersion === 0"
        :index="index"
        :lastIndex="selectedStep.orderSections.length - 1"
        :cards-order-update="cardsOrderUpdate"
        :products="products"
        :help-center-list="selectedStep.helpCenters"
        :product-name="productName"
      />
    </template>
  </div>
</template>

<style scoped lang="scss">
@import "@/styles/media";
.digitize-cards {
  position: relative;
  display: flex;
  margin-top: 60px;

  &__top-buttons {
    position: absolute;
    top: -50px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    display: flex;
    justify-content: space-between;
  }

  &__button {
    margin: 0 16px;
  }
}
</style>
